"use client"

import desktopImageDark from "@/public/marketing/product-demo/Desktop_Dark.png"
import desktopImageLight from "@/public/marketing/product-demo/Desktop_Light.png"
import mobileImageDark from "@/public/marketing/product-demo/Phone (1).png"
import mobileImageLight from "@/public/marketing/product-demo/Phone-1 (2).png"
import { motion, useScroll, useTransform } from "motion/react"

import Image from "next/image"
import React, { useEffect, useState } from "react"

export const ProductDemoSection = () => {
  const [isMd, setIsMd] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMd(window.innerWidth <= 900)
    }

    handleResize() // Initial check
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const containerRef = React.useRef(null)

  // Use scroll progress relative to the section
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"], // Starts when section enters viewport, ends when it leaves
  })

  // Create smooth parallax effects
  const mobileY = useTransform(scrollYProgress, [0, 1], [200, 0])
  const mdMobileY = useTransform(scrollYProgress, [0, 1], [100, 0])

  return (
    <div ref={containerRef}>
      <div className="relative mx-auto hidden w-fit flex-col items-center dark:flex">
        <motion.div>
          <Image
            src={desktopImageDark}
            alt="Dark mode desktop demo"
            width={3071}
            height={2017}
            className="w-full sm:w-[800px]"
            loading="lazy"
          />
        </motion.div>
        <motion.div
          style={{ y: isMd ? mdMobileY : mobileY, x: isMd ? "25%" : "50%" }}
          className="absolute bottom-0 right-[0]">
          <Image
            src={mobileImageDark}
            alt="Dark mode app demo"
            width={1321}
            height={2238}
            className="w-[33vw] md:w-[280px]"
            loading="lazy"
          />
        </motion.div>
      </div>

      <div className="relative mx-auto flex w-fit flex-col items-center dark:hidden">
        <motion.div>
          <Image
            src={desktopImageLight}
            alt="Light mode desktop demo"
            width={3071}
            height={2017}
            className="w-full sm:w-[800px]"
            loading="lazy"
          />
        </motion.div>
        <motion.div
          style={{ y: isMd ? mdMobileY : mobileY, x: isMd ? "25%" : "50%" }}
          className="absolute bottom-0 right-[0]">
          <Image
            src={mobileImageLight}
            alt="Ligh mode desktop demo"
            width={1321}
            height={2238}
            className="w-[33vw] md:w-[280px]"
            loading="lazy"
          />
        </motion.div>
      </div>
    </div>
  )
}
